import { Box, Icon, Text } from '@rbilabs/universal-components';

import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

type CashappErrorProps = {
  type?: 'declined' | 'failed';
};
export function CashappError({ type = 'declined' }: CashappErrorProps) {
  const message = type === 'declined' ? t('cashAppDecline') : t('cashAppError');

  useLogUserErrorMessage({
    message: 'CashAppButton: ' + message,
    severity: LogUserErrorSeverity.Recoverable,
  });

  return (
    <ErrorContainer>
      <Icon variant="warning" size={'4'} marginRight={2} />
      <ErrorText>{message}</ErrorText>
    </ErrorContainer>
  );
}

export const ErrorContainer = Box.withConfig({
  backgroundColor: primitive.$errorLight,
  marginBottom: '$6',
  paddingX: '$6',
  paddingY: '$2',
  paddingRight: '$6',
  flexDirection: 'row',
  alignItems: 'center',
});

export const ErrorText = Text.withConfig({
  color: primitive.$bbqBrown,
  fontSize: 'sm',
});
